/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { Button } from 'react-bootstrap';
import * as S from './styles';
export interface IBodyCompProps {
  email?: string;
  imageUrl?: string;
  headerTitle?: string;
  headerSubTitle?: string;
  subTitle?: string;
  description?: string;
  buttonTitle?: string;
  policyNumber?: string;
  policyTitle?: string;
  verifyPhone?: boolean;
  verifyPhoneText?: string;
  verifyButtonText?: string;
  onButtonClick?(): void;
  onVerifyPhoneClick?(): void;
}

export const Conclusion = (props: IBodyCompProps) => {
  const {
    email,
    headerTitle,
    headerSubTitle,
    subTitle,
    description,
    buttonTitle,
    imageUrl,
    policyTitle,
    policyNumber,
    verifyPhone,
    verifyButtonText,
    verifyPhoneText,
    onVerifyPhoneClick,
    onButtonClick,
  } = props;
  return (
    <>
      <S.Background>
        <S.Image alt={'success'} src={imageUrl} width={200} />
        <S.Title>{headerTitle} </S.Title>
        <S.Title>
          {policyTitle} {policyNumber}
        </S.Title>
        <S.Title>
          {headerSubTitle} {email}
        </S.Title>
        <S.SubTitle>{subTitle}</S.SubTitle>
        <S.Description>{description}</S.Description>
        {verifyPhone && (
          <S.VerifyPhoneText>
            <S.VerifyButtonText
              onClick={() => {
                onVerifyPhoneClick && onVerifyPhoneClick();
              }}
            >
              {verifyButtonText}
            </S.VerifyButtonText>{' '}
            {verifyPhoneText}
          </S.VerifyPhoneText>
        )}
        <S.ButtonContainer>
          <Button
            className="me-3 mb-4"
            variant="outline-secondary"
            size="lg"
            onClick={onButtonClick}
          >
            {buttonTitle}
          </Button>
        </S.ButtonContainer>
      </S.Background>
    </>
  );
};
Conclusion.defaultProps = {
  imageUrl:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.images/provisionalpolicy_screen.png',
  headerTitle: 'Thank You !',
  headerSubTitle:
    'Your Transaction  is now complete and recorded in blockchain, you can view in transactions tab',
};
